define('modules/Product/FinalSaleProductPrice',[
        'jquery',
        'global/all',
        './ProductPricingService',
        './ProductUnitsOfMeasureHelper',
        'modules/Delivery//DeliveryZipCodeService',
        'modules/Store/StorePermissionService'
],
    function ($, Roc, ProductPricingService, ProductUnitsOfMeasureHelper, DeliveryZipCodeService, StorePermissionService) {
        'use strict';

        var selectors = {
            'pricingWrapper': '[data-roc-binding="pricing"]'
        };

        function render(finalSaleViewModel) {
            Roc.UI.template('finalSaleProductPricingDetails-Tmp', finalSaleViewModel).then(function (renderedTemplate) {
                $(selectors.pricingWrapper).html(renderedTemplate);
            });
        }


        function init(finalSaleViewModel) {
            if (!StorePermissionService.canSeePricing()) {
                return;
            }

            render();
        }

        var DynamicProductPrice = {
            init: init
        };

        Roc.Logger.debug('DynamicProductPrice.js Loaded:', DynamicProductPrice);

        return DynamicProductPrice;
    });
